import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '..';

type State = {
  booted: boolean;
};

const initialState: State = {
  booted: false,
};

const bootProcessSlice = createSlice({
  name: 'bootProcess',
  initialState,
  reducers: {
    updateBootProcessComplete(state: State) {
      state.booted = false;
    },
  },
});

export const { updateBootProcessComplete } = bootProcessSlice.actions;

const _selectBootProcess = (state: RootState) => state.bootProcess.booted;

export default bootProcessSlice.reducer;
